import uploadedVehicleComponent from './uploadedVehicles.component';
import uploadedVehicleService from './uploadedVehicles.service';

export const uploadedVehiclesModule = angular
    .module('uploadedVehicles', [])
    .component('uploadedVehicles', uploadedVehicleComponent)
    .service('$uploadedVehicles', uploadedVehicleService);



/** WEBPACK FOOTER **
 ** ./frontend/components/uploadedVehicles/uploadedVehicles.js
 **/